import { Box, Stack, Typography } from "@mui/material";
import { useState } from "react";
import loadingLogo from "../../media/logo/platformpuffin-loading.svg";

const loadingSubtitles = [
  "Waking up the resident puffin.",
  "Putting the kettle on for the servers.",
  "Untangling a few curly brackets.",
  "Giving the pixels a pep talk.",
  "Counting clouds. The digital kind.",
  "Finding the matching USB sock.",
  "Bribing the router with breadcrumbs.",
  "Rolling out the welcome bitmap.",
  "Fluffing the puffin's feathers.",
  "Checking under the couch for bytes.",
  "Warming up the hamster wheel.",
  "Aligning the tiny digital planets.",
  "Folding the internet into neat piles.",
  "Adding a pinch of pixel dust.",
  "Assembling your cloud sandwich.",
  "Convincing the bits to hold hands.",
  "Sending a puffin on a coffee run.",
  "Dusting off the dashboard.",
  "Inflating the progress balloons.",
  "Finding north on the mouse compass.",
  "Teaching the buttons their lines.",
  "Lacing up the loading sneakers.",
  "Making room for one more byte.",
  "Tuning the server orchestra.",
  "Herding a small flock of tabs.",
  "Ironing out the curly cables.",
  "Packing a picnic for the packets.",
  "Checking the puffin's flight plan.",
  "Stirring the alphabet soup.",
  "Waiting for the toast to compile.",
  "Giving the cache a gentle nudge.",
  "Painting racing stripes on the data.",
  "Sorting ones from very thin zeros.",
  "Putting fresh batteries in the cloud.",
  "Asking the octopus to multitask.",
  "Making the electrons feel welcome.",
  "Looking for the any key.",
  "Rehearsing the grand tab opening.",
  "Sprinkling confetti in the console.",
  "Filling the puffin's snack drawer.",
  "Inflating a slightly flat algorithm.",
  "Walking the cursor around the block.",
  "Serving cookies to the cookie jar.",
  "Telling the firewall a warm joke.",
  "Knitting a sweater for the server.",
  "Drawing a map for lost semicolons.",
  "Making sure the ducks are in rows.",
  "Taking the scenic route through RAM.",
  "Giving the icons their name tags.",
  "Topping up the imagination tank.",
  "Chasing a runaway parenthesis.",
  "Feeding the bandwidth a bagel.",
  "Putting tiny helmets on the bits.",
  "Conducting the keyboard choir.",
  "Unboxing a fresh batch of pixels.",
  "Calling the puffin to the bridge.",
  "Reading the clouds a bedtime story.",
  "Rolling the data uphill.",
  "Adding extra bounce to the buttons.",
  "Making a nest for your next idea.",
  "Training the spinner for a marathon.",
  "Sweeping crumbs out of the keyboard.",
  "Shuffling the digital deckchairs.",
  "Inviting the bytes to breakfast.",
  "Checking the wind beneath our wings.",
  "Turning coffee into clickable things.",
  "Rescuing a tab from behind the sofa.",
  "Watering the binary tree.",
  "Putting the moon in dark mode.",
  "Practicing synchronized buffering.",
  "Fitting the cloud with rain boots.",
  "Waving the packets through customs.",
  "Coaxing the cursor out of hiding.",
  "Tucking in the loose threads.",
  "Giving the database a bow tie.",
  "Making space for a little magic.",
  "Sending the spinner some applause.",
  "Waking the sleeping dropdowns.",
  "Putting the bits in alphabetical order.",
  "Finding a parking spot for the cloud.",
  "Teaching the puffin a keyboard shortcut.",
  "Pouring a fresh cup of uptime.",
  "Untying the internet's shoelaces.",
  "Setting the table for your tabs.",
  "Checking the pixels for bedhead.",
  "Taking the training wheels off the UI.",
  "Tuning in to the right wavelength.",
  "Rolling a tiny red carpet.",
  "Giving the functions a coffee break.",
  "Building a blanket fort in the cloud.",
  "Finding the end of the loading rainbow.",
  "Adding a little zest to the requests.",
  "Making the scrollbars feel included.",
  "Asking the puffin for directions.",
  "Folding paper planes for the payloads.",
  "Turning the gears with tiny flippers.",
  "Checking the forecast for flying fish.",
  "Opening the curtains on your workspace.",
  "Putting the finishing chirps on things.",
  "Saving you a seat by the window.",
] as const;

const loadingIndicatorSizes = {
  large: 400,
} as const;

export interface LoadingIndicatorProps {
  "aria-label"?: string;
  size?: keyof typeof loadingIndicatorSizes;
  showSubtitle?: boolean;
  subtitleIndex?: number;
}

export const LoadingIndicator = ({ "aria-label": ariaLabel = "Loading", size = "large", showSubtitle = false, subtitleIndex }: LoadingIndicatorProps) => {
  const [randomSubtitleIndex] = useState(() => Math.floor(Math.random() * loadingSubtitles.length));
  const selectedSubtitleIndex = subtitleIndex === undefined ? randomSubtitleIndex : Math.abs(subtitleIndex) % loadingSubtitles.length;

  return (
    <Stack sx={{ alignItems: "center" }}>
      <Box
        component="img"
        src={loadingLogo}
        alt=""
        aria-label={ariaLabel}
        role="status"
        sx={{ display: "block", width: loadingIndicatorSizes[size], height: loadingIndicatorSizes[size] }}
      />
      {showSubtitle ? (
        <Typography variant="h6" color="text.secondary" sx={{ mt: -2 }}>
          {loadingSubtitles[selectedSubtitleIndex]}
        </Typography>
      ) : null}
    </Stack>
  );
};
